'use client';

import {motion} from 'framer-motion';
import useTopStyle from 'utils/useTopStyle';
import BookBtn from '../buttons/BookBtn/BookBtn';
import heroVariants from 'animation/heroVariants';
import spanVariants from 'animation/spanVariants';
import ObservabilityHeroSvg from 'animation/svg-anim/ObservabilityHeroSvg';

const ObservabilityHero = () => {
  const ref = useTopStyle(72);

  return (
    <motion.section
      className='observability-hero'
      ref={ref}
      initial={'hidden'}
      animate={'visible'}
      transition={{
        duration: 0.7,
        delay: 0.5,
        ease: 'easeInOut'
      }}
      variants={heroVariants}
    >
      <div className='container'>
        <div className='bg-line'>
          <ObservabilityHeroSvg />
        </div>
        <div className='content'>
          <h2 className='title'>
            Scalable cloud platform, ultimate
            <motion.span
              className='highlight'
              initial={'hidden'}
              animate={'visible'}
              transition={{
                duration: 0.8,
                delay: 0.8,
                ease: 'easeInOut'
              }}
              variants={spanVariants}
            >
              observability
            </motion.span>
          </h2>
          <p className='text'>Make sense of the flood of data with a powerful yet friendly analytical interface and cloud engine.</p>
          <BookBtn />
        </div>
        <div className='design'></div>
      </div>
    </motion.section>
  );
};

export default ObservabilityHero;

